import type { ReactNode } from 'react';

/**
 * The shell every signed-out screen sits on.
 *
 * One component rather than a card repeated in three files: login, both rejection
 * screens and the callback all render here, so signing out lands you on a page that
 * looks like the one you left.
 *
 * NOTE the missing inline background on the outer div. It used to carry
 * `style={{ background: 'var(--canvas)' }}`, which silently killed the artwork: an
 * inline style beats a class rule, and the `background` SHORTHAND resets
 * background-image to none along the way. The colour is set in .auth-bg with the image.
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="auth-bg flex h-full items-center justify-center p-6">
      <div
        className="w-full max-w-sm rounded-2xl border p-8 text-center"
        style={{
          borderColor: 'var(--border)',
          background: 'var(--surface)',
          boxShadow: 'var(--shadow-panel)',
        }}
      >
        {children}
      </div>
    </div>
  );
}
